import { useAuthInfo } from '@propelauth/react';

export default function useIsCalyxTeamMember(): boolean {
  const authInfo = useAuthInfo();
  const org = authInfo.orgHelper?.getOrgs()?.[0];
  const isCalyxTeamMember = org?.orgName.toLowerCase() === 'calyx global';

  return isCalyxTeamMember;
}
